import { USER_FOUND, USER_EXPIRED } from "redux-oidc";

const initialState = { hasUserLoggedIn: null, hasUserExpired: null };

export default function OIDCAccountReducer(state = initialState, action) {
  switch (action && action.type) {
    case USER_FOUND:
      return { ...state, hasUserLoggedIn: true, hasUserExpired: false };
    case USER_EXPIRED: {
      return { ...state, hasUserExpired: true };
    }
    default:
      return { ...state };
  }
}
